"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _labelManagement = require("@/api/member/labelManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MarketingEvents',
  data: function data() {
    return {
      options: [],
      queryData: {
        labelName: '',
        minCount: '',
        maxCount: '',
        page: 1,
        size: 10
      },
      tableData: [],
      total: 0,
      // 条数

      eventsType: 'add',
      // 事件类型
      dialogVisible: false,
      // 弹窗
      ruleForm: {
        id: null,
        labelName: '',
        remark: ''
      },
      rules: {
        labelName: [{
          required: true,
          message: '请输入标签名称',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.labelPage();
  },
  methods: {
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.labelName = '';
      this.ruleForm.remark = '';
    },
    // 添加-------------
    onAdd: function onAdd() {
      this.eventsType = 'add';
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.ruleForm = {
        labelName: '',
        remark: ''
      };
      this.resetForm('ruleForm');
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.eventsType === 'add') {
            _this.addLabel();
          } else {
            _this.$confirm('当前页配置信息发生修改,是否确认修改内容?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this.editLabel();
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    addLabel: function () {
      var _addLabel2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                labelName: this.ruleForm.labelName,
                remark: this.ruleForm.remark
              };
              _context.n = 1;
              return (0, _labelManagement.addLabel)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.$message.success('标签添加成功');
                this.handleClose();
                this.labelPage();
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function addLabel() {
        return _addLabel2.apply(this, arguments);
      }
      return addLabel;
    }(),
    editLabel: function () {
      var _editLabel2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context2.n = 1;
              return (0, _labelManagement.editLabel)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message.success('标签编辑成功');
                this.handleClose();
                this.labelPage();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function editLabel() {
        return _editLabel2.apply(this, arguments);
      }
      return editLabel;
    }(),
    deleteLabel: function () {
      var _deleteLabel2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(id) {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                id: id
              };
              _context3.n = 1;
              return (0, _labelManagement.deleteLabel)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$message.success('标签删除成功');
                this.onInitialize();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function deleteLabel(_x) {
        return _deleteLabel2.apply(this, arguments);
      }
      return deleteLabel;
    }(),
    onEditor: function onEditor(item) {
      this.ruleForm.id = item.id;
      this.ruleForm.labelName = item.labelName;
      this.ruleForm.remark = item.remark;
      this.eventsType = 'edit';
      this.dialogVisible = true;
    },
    onDelete: function onDelete(item) {
      var _this2 = this;
      this.$confirm('是否确认删除该标签?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.deleteLabel(item.id);
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onDetails: function onDetails(data) {
      console.log('data', data);
      this.$router.push({
        path: '/orderManagement/orderDetails',
        query: {
          orderNo: data.orderNo,
          unionCode: data.platformCode
        }
      });
    },
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.labelPage();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        labelName: '',
        minCount: '',
        maxCount: '',
        page: 1,
        size: 10
      };
      this.labelPage();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.labelPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.labelPage();
    },
    labelPage: function () {
      var _labelPage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context4.n = 1;
              return (0, _labelManagement.labelPage)(params);
            case 1:
              res = _context4.v;
              this.tableData = res.data.data;
              this.total = res.data.total;
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function labelPage() {
        return _labelPage2.apply(this, arguments);
      }
      return labelPage;
    }(),
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        name: 'membershipList',
        params: {
          labelId: value.id
        }
      });
    }
  }
};